<template>
  <div class="header-inner">
    <!-- <div class="breadcrumb">
      <breadcrumb></breadcrumb>
    </div> -->
    <!-- 消息通知 -->
    <!-- <div class="message hover-active">
      <a-badge count="7">
        <a-icon type="bell" />
      </a-badge>
    </div> -->
    <div class="account hover-active">
      <a-dropdown>
        <a class="ant-dropdown-link" v-if="userInfo.roleId == 3">
          <span class="account-name" @click="myCenter()"
            >{{ userInfo.schoolName }}
          </span>
          <span v-show="userInfo.schoolName != userInfo.username">
            ({{ userInfo.username }})
          </span>
          <a-icon class="account-icon" type="down" />
        </a>
        <a class="ant-dropdown-link" v-if="userInfo.roleId == 4">
          <span class="account-name" @click="myCenter()"
            >{{ userInfo.institutionName }}
          </span>
          <span v-show="userInfo.institutionName != userInfo.username">
            ({{ userInfo.username }})
          </span>
          <a-icon class="account-icon" type="down" />
        </a>
        <a class="ant-dropdown-link" v-else>
          <span class="account-name" @click="myCenter()"
            >{{ userInfo.username || userInfo.mobile }}
          </span>
          <a-icon class="account-icon" type="down" />
        </a>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="0" @click="myCenter()">
            <a-icon type="user" />
            <span class="custom-menu-item">个人中心</span>
          </a-menu-item>
          <a-menu-item key="1" v-if="schoolList.length" @click="changeSchool()">
            <a-icon type="swap" />
            <span class="custom-menu-item">切换学校</span>
          </a-menu-item>
          <a-menu-item key="2" @click="logout()">
            <a-icon type="logout" />
            <span class="custom-menu-item">退出登录</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <center-school-modal
      ref="centerSchool"
      :schoolList="schoolList"
    ></center-school-modal>
    <!--  -->
    <!-- <div v-if="visible || visible1" class="selectSchool" @mousemove="enterMenu1" @mouseleave="levelMenu1">
			<a-input class="input" placeholder="输入学校名称" @change="searchSchool" v-model="inputValue"></a-input>
			<div class="scroll">
				<div v-if="inputValue ? item.schoolName.indexOf(inputValue) > -1 : 1" v-for="item in schoolList" :key="item.id" @click="chooseSchool(item)">
					<a :href="item.link">{{ item.schoolName }}</a>
				</div>
			</div>
		</div> -->
  </div>
</template>
<script>
import breadcrumb from './Breadcrumb'
import user from '/src/api/user'
import CenterSchoolModal from '/src/views/user/CenterSchoolModal.vue'
export default {
  name: 'customheader',
  data() {
    return {
      userInfo: {},
      visible: false,
      visible1: false,
      options: [],
      inputValue: '', // 搜索框内容
      schoolList: [], // 学校列表
    }
  },
  components: {
    breadcrumb,
    CenterSchoolModal,
  },
  // watch: {
  // 	// 模糊查询学校
  // 	inputValue(newVal) {
  // 		if (newVal) {
  // 			this.serachList = [];
  // 			this.schoolList.forEach(v => {
  // 				if (v.schoolName.indexOf(newVal) >= 0) {
  // 					this.serachList.push(v);
  // 				}
  // 			});
  // 		} else if (newVal == '') {
  // 			this.serachList = [];
  // 		}
  // 	}
  // },
  methods: {
    getSchoolList() {
      let requestFun = user.getSchoolList
      requestFun().then((res) => {
        this.schoolList = res.data == 'NON' ? [] : res.data
      })
    },
    myCenter() {
      this.$router.push({ name: 'userCenter' })
    },
    changeSchool() {
      this.$refs.centerSchool.init()
    },
    logout() {
      let self = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          user.logout()
          //退出时给菜单页权限页面给清除掉
          let routerList = self.$router.options.routes
          if (routerList[0] && routerList[0].children) {
            routerList[0].children = []
          }
          self.clearCookie()

          self.$router.selfaddRoutes(routerList)
          self.schoolList.length
            ? self.$router.push('CenterManageLogin')
            : self.$router.push('login')
          //清除缓存
          self.$store.commit('CLEARLOGIN')
          window.menuList = null
        },
      })
    },
    // 清除cookie
    clearCookie() {
      // let requestFun = ;
      user.exit().then((res) => {})
    },
    enterMenu() {
      this.visible = true
      console.log('123', this.visible)
      // this.visible1 = true;
    },
    enterMenu1() {
      console.log(111111111)
      this.visible1 = true
    },
    levelMenu() {
      console.log(111)
      // this.visible = false;
      setTimeout(() => {
        this.visible = false
      }, 500)
    },
    levelMenu1() {
      this.visible1 = false
      // this.visible1 = false;
    },
    handleMenuClick(e) {
      console.log('222', e)
    },
    searchSchool(e) {
      console.log(e)
    },
    chooseSchool(e) {
      console.log(e)
    },
  },
  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      console.log('userInfo', res)
      this.userInfo = res
    })
    this.getSchoolList()
  },
}
</script>
<style lang="scss" scoped>
.header-inner {
  height: 64px;
  line-height: 64px;
  background: white;
  padding: 0px 30px;
  box-shadow: 3px 1px 4px rgba(0, 21, 41, 0.08);
  text-align: right;
  font-size: 16px;
  vertical-align: middle;
  position: relative;

  .selectSchool {
    position: absolute;
    top: 112px;
    right: 168px;
    background: #ffffff;
    box-shadow: 3px 1px 4px rgba(0, 21, 41, 0.08);
    width: 200px;
    height: 177px;
    z-index: 999;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .input {
      height: 32px;
      margin: 0 !important;
    }
    .scroll {
      width: 100%;
      height: 140px;
      text-align: left;
      margin: auto 0 0;
      overflow: scroll;
      div {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px !important;
        padding: 0 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        a {
          color: #000000;
        }
      }
      div:hover {
        background-color: #eefbff;
      }
    }
    .scroll::-webkit-scrollbar {
      display: none;
    }
  }
}
.header-inner > div {
  display: inline-block;
  position: relative;
}

.breadcrumb {
  float: left;
  line-height: 64px;
}
.message {
  padding: 0px 15px 0px 10px;
  font-size: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.account {
  margin-left: 10px;
  padding: 0px 14px;
  cursor: pointer;
}

.account > a {
  display: inline-block;
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  margin-right: 5px;
}
.custom-menu-item {
  display: inline-block;
  width: 80px;
}
.account-icon {
  display: inline-block;
  margin-left: 2px;
}
</style>
